<template>
  <b-form-group
    label="Mülk Kodu"
    label-for="ecode"
  >
    <validation-provider
      #default="{ errors }"
      name="Mülk Kodu"
      rules="required"
    >
      <b-form-input
        id="ecode"
        v-model="dataItem.ecode"
        placeholder="Mülk Kodu"
      />
      <small class="text-danger">{{ errors[0] }}</small>
    </validation-provider>
  </b-form-group>
</template>

<script>
import { ValidationProvider, localize } from 'vee-validate'
import {
  BFormGroup, BFormInput,
} from 'bootstrap-vue'
import { required } from '@validations'

export default {
  name: 'EstateCode',
  components: {
    BFormGroup,
    BFormInput,
    ValidationProvider,
  },
  data() {
    return {
      required,
    }
  },
  computed: {
    dataItem() {
      return this.$store.getters['estates/dataItem']
    },
  },
  created() {
    localize('tr')
  },
}
</script>
